import React, {useState, useEffect} from 'react';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import HomeIcon from "@mui/icons-material/Home";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {config} from "./config";
import {HashLoader} from "react-spinners";
import TagStack from "./components/tags";
import Pagination from '@mui/material/Pagination';
import Checkbox from '@mui/material/Checkbox';
// import {useSearchParams} from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Footer from "./components/footer";


function HomePage() {
    const [loading, setLoading] = useState(true);
    // let [searchParams, setSearchParams] = useSearchParams();
    const API_URL = config.api_url;

    const [datasets, setDatasets] = useState([]);
    const [datasets_count, setDatasetCount] = useState(null);
    const [page, setPage] = useState(1);
    const [csvonly, setCSVOnly] = useState(true);
    const [order, setOrder] = useState('asc');
    const [total_pages, setTotalPages] = useState(0);
    const [user_page_num, setUserPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchEngine, setSearchEngine] = useState("mongo");
    const [usingSearch, setUsingSearch] = useState(false);
    const ds_per_page = config.ds_per_page;


    // for (const [key, value] of searchParams.entries()) {
    //     console.log(`${key}, ${value}`);
    // }

    async function fetchData(mode = "") {
        setLoading(true);
        let requestOptions = {};
        if (mode === "search") {
            setUsingSearch(true);
            requestOptions = {
                method: 'POST',
                mode: 'cors',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    "csv_only": csvonly,
                    "page": page,
                    "search_engine": searchEngine,
                    "search_query": searchQuery
                })
            };
        } else {
            setUsingSearch(false);
            requestOptions = {
                method: 'POST',
                mode: 'cors',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    "csv_only": csvonly,
                    "page": page,
                    "order": order,
                    "sort_by": "name"
                })
            };
        }


        try {
            fetch(API_URL + '/datasets', requestOptions)
                .then((res) => {
                    if (res.ok) {
                        return res.json()
                    } else {
                        return Promise.reject('error');
                    }
                })
                .then((data) => {
                    setDatasets(data.datasets);
                    setDatasetCount(data.total_count);
                })
                .catch(error => console.log('error is', error))
                .finally(() => setLoading(false));
        } catch (error) {
            console.error('Error fetching datasets:', error);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchQuery) {
            fetchData("search");
        } else {
            fetchData();
        }
    }, [page]);

    useEffect(() => {
        setPage(1);
        fetchData();
    }, [csvonly, order]);

    useEffect(() => {
        setTotalPages(Math.ceil(datasets_count / ds_per_page));
    }, [datasets_count])

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    const handleChangeCSVOnly = (event) => {
        setCSVOnly(event.target.checked);
    };

    const handleChangeOrder = (event) => {
        setOrder(event.target.value);
    };

    const onClickPageGo = () => {
        setPage(user_page_num);
    };

    const onChangeUserPage = (event) => {
        setUserPage(Number(event.target.value));
    };

    const onClickSearch = () => {
        // setPage(user_page_num);
        if (searchQuery) {
            fetchData("search");
        }
    };

    const onChangeSearch = (event) => {
        setSearchQuery(event.target.value);
        // setUserPage(Number(event.target.value));
    };

    const keyPressSearch = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            onClickSearch();
        }
    };

    const handleChangeSearchEngine = (event) => {
        setSearchEngine(event.target.value);
    };

    const keyPress = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            if (user_page_num > 0 && user_page_num <= total_pages) {
                setPage(user_page_num);
            }
        }
        console.log(user_page_num);
    };

    return (<div style={{marginLeft: "5%", marginRight: "5%", marginTop: "3%"}}>
        {loading ?
            <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}><HashLoader
                loading={loading}
                size={100}
                aria-label="Loading Spinner"
                data-testid="loader"
                color={"#36d7b7"}
            /></div> : ""}
        <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href={`${config.web_prefix}/`}>
                <HomeIcon fontSize="small"/> Home
            </Link>
        </Breadcrumbs>
        <Typography variant="h3">
            Datasets
        </Typography>

        {/*{loading ?*/}
        {/*    <div>*/}
        {/*        <Stack spacing={1}>*/}
        {/*            /!* For variant="text", adjust the height via font-size *!/*/}
        {/*            /!* For other variants, adjust the size with `width` and `height` *!/*/}
        {/*            <Skeleton variant="rectangular" width={"100%"} height={440} animation="wave"/>*/}
        {/*            <Skeleton variant="rounded" width={210} height={60} />*/}
        {/*        </Stack>*/}
        {/*    </div> : ""*/}
        {/*}*/}

        <Box component="form"
             sx={{
                 '& > :not(style)': {m: 1, width: '20ch'},
             }}>
            <FormControlLabel control={<Checkbox
                checked={csvonly}
                onChange={handleChangeCSVOnly}
                inputProps={{'aria-label': 'controlled'}}
                sx={{m: 1, maxWidth: 120}}
            />} label="CSV only"/>
            <FormControl variant="standard" sx={{m: 1, maxWidth: 120}}>
                <InputLabel id="demo-simple-select-label">Order by name</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={order}
                    label="Order by name"
                    onChange={handleChangeOrder}
                >
                    <MenuItem value={"asc"}>ASC</MenuItem>
                    <MenuItem value={"desc"}>DESC</MenuItem>
                </Select>
            </FormControl>
            <FormControl variant="standard" sx={{m: 1, maxWidth: 180}}>
                <InputLabel id="id-select-search-engine">Search Engine</InputLabel>
                <Select
                    labelId="id-select-search-engine-label"
                    id="id-select-search-engine-select"
                    value={searchEngine}
                    label="Search Engine"
                    onChange={handleChangeSearchEngine}
                >
                    <MenuItem value={"mongo"}>Mongo</MenuItem>
                    <MenuItem value={"llm_title"}>LLM -- Title</MenuItem>
                    <MenuItem value={"llm_notes"}>LLM -- Notes</MenuItem>
                </Select>
            </FormControl>
        </Box>

        <Box component="form"
             sx={{
                 '& > :not(style)': {m: 1, width: '20ch'},
             }}>
            <TextField id="id-input-serach-query" label="Search Box" type="text" onChange={onChangeSearch}
                       onKeyDown={keyPressSearch}
                       style={{width: '40ch'}}
                // error={(user_page_num < 0 || user_page_num > total_pages)}
                // helperText={`Should between 1 and ${total_pages}.`}
            />
            <Button variant="outlined" onClick={onClickSearch}
                    disabled={!searchQuery} size="small"
                    style={{paddingTop: "2%"}}>Search</Button>
        </Box>

        {datasets.length > 0 ? <Box sx={{width: '100%', marginTop: '10px'}}>
            <Stack spacing={5}>
                {datasets.map((dataset) => (<Card sx={{minWidth: 275}} key={dataset.name} variant="outlined">
                    <CardContent>
                        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                            {dataset.organization ? dataset.organization.title : "No Organization Information"}
                        </Typography>
                        <Typography variant="h5" component="div">
                            {dataset.title}
                        </Typography>
                        <Typography sx={{mb: 1.5}} color="text.secondary">
                            <Link target="_blank"
                                  href={"https://catalog.data.gov/dataset/" + dataset.name}>DATA GOV LINK</Link>
                        </Typography>
                        <Typography variant="body1" component="div">
                            <strong>Note:</strong>
                            {dataset.notes}
                        </Typography>
                        <Typography>
                            <TagStack tags={dataset.tags}/>
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Link href={`${config.web_prefix}/dataset/${dataset.name}`} target={"_blank"}>
                            <Button variant="contained" size="small">Learn More</Button>
                        </Link>
                    </CardActions>
                </Card>))}
            </Stack>
            {(usingSearch && searchEngine !== "mongo") ? "" : <Stack spacing={2} alignItems="center" style={{paddingTop: "3%", marginBottom: "2%"}}>
                <Pagination count={total_pages} page={page} onChange={handleChangePage} disabled={loading} size="large"
                            siblingCount={5}/>
                <Box component="form"
                     sx={{
                         '& > :not(style)': {m: 1, width: '20ch'},
                     }}>
                    <TextField id="id-input-page-number" label="Page Number" type="number" onChange={onChangeUserPage}
                               onKeyDown={keyPress}
                               error={(user_page_num < 0 || user_page_num > total_pages)}
                               helperText={`Should between 1 and ${total_pages}.`}/>
                    <Button variant="outlined" onClick={onClickPageGo}
                            disabled={loading || user_page_num <= 0 || user_page_num > total_pages} size="small"
                            style={{paddingTop: "2%"}}>Go!</Button>
                </Box>
            </Stack>}

        </Box> : "No dataset returned."}

        <Footer/>
    </div>);
}

export default HomePage